import React from "react";
import "./particleStyles.css"
import particlesConfig from "../../config/ParticleJsConfig"


const Particle = () => {

    return (
        <div>
             <div className="particle-content">
                <div className="particle-wrapper">
                
                </div>
            </div>
        </div>
        
       
    )
}

export default Particle